import { loveQuotes } from "../Data/loveQuotes";

function ForYouMySoul() {
  return (
    <div className="LessonsPage">
      <h1>For You, My Soul</h1>
      <h2>My true thoughts, about us</h2>
      <ul>
        {loveQuotes.map((quote, index) => (
          <li key={index}>
            <blockquote>{quote.text}</blockquote>
            <small
              style={{
                backgroundColor: quote.color,
                padding: "4px 8px",
                borderRadius: "6px",
                display: "inline-block",
                marginTop: "6px",
              }}
            >
              Added on: {quote.date}
            </small>

          </li>
        ))}
      </ul>
    </div>
  );
}

export default ForYouMySoul;
